import { Images } from '../assets'
import React, { useState } from 'react'
import { Routes, Route, Link } from 'react-router-dom'
import PageTitle from '../components/PageTitle'
import ProjectCard from '../components/ProjectCard'
import Tag from '../components/Tag'

import ProjectShowcase from './ProjectShowcase'

const placeholderImg = (label) =>
  `data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="600" height="400"><rect width="600" height="400" fill="#E6F0FF"/><text x="300" y="200" text-anchor="middle" dominant-baseline="middle" fill="#7E7E7E" font-size="18" font-family="sans-serif">${label}</text></svg>`
  )}`

const SECTOR_OPTIONS = [
  'All sectors',
  'Tuberculosis',
  'Cancer detection',
  'Civil registration',
  'Laboratory services',
  'Vaccination tracking',
  'Electronic health records',
  'Health insurance',
  'Surgery',
  'Birth defects',
  'National health information systems',
  'Community health',
  'Rural health',
  'Vital statistics',
  'National information systems',
  'HIV testing',
  'Service delivery',
  'Patient retention',
  'Primary health care',
  'System evaluation',
]

const GEOGRAPHY_OPTIONS = [
  'All geographies',
  'Federal Capital Territory',
  'Lagos State',
  'Nasarawa State',
  'Ekiti State',
  'Rivers State',
  'Katsina State',
  'Benue State',
  'Gombe',
  'Kwara',
  'Anambra',
  'Ebonyi',
  'Nationwide',
  'Rural Nigeria',
]

const allProjects = [
  {
    id: 'clientshot-fct',
    title: 'FCT Health Insurance Awareness and Enrollment Assessment',
    client: 'Institute of Human Virology Nigeria (IHVN)',
    sector: ['Health insurance'],
    geography: ['Federal Capital Territory'],
    outcome: '54,836 responses collected across 99 health facilities across all 6 Area Councils',
    image: Images.ClientshotProjectCard,
    bgColor: 'purple',
    link: '/projects/clientshot-fct',
    published: true,
  },
  {
    id: 'clientshot-nasarawa',
    title: 'Nasarawa State Health Insurance Awareness and Enrollment Assessment',
    client: 'Institute of Human Virology Nigeria (IHVN)',
    sector: ['Health insurance'],
    geography: ['Nasarawa State'],
    outcome: '65,514 responses collected across 125 health facilities in all 13 LGAs',
    image: Images.Deployment4,
    bgColor: 'purple',
    link: '/projects/clientshot-nasarawa',
    published: true,
  },
  {
    id: 'clientshot-apin-benue',
    title: 'APIN CQI Programme – Appointment Compliance in Benue State',
    client: 'APIN Public Health Initiatives',
    sector: ['Service delivery'],
    geography: ['Benue State'],
    outcome: '22,570 patient feedback records captured across 26 health facilities',
    image: Images.Apin01,
    bgColor: 'purple',
    link: '/projects/clientshot-apin-benue',
    published: true,
  },
  {
    id: 'clientshot-nthrip',
    title: 'IHVN Global Fund N-THRIP Continuous Quality Improvement Programme',
    client: 'Institute of Human Virology Nigeria (IHVN)',
    sector: ['Service delivery'],
    geography: ['Gombe', 'Kwara', 'Anambra', 'Ebonyi'],
    outcome: 'Clientshot deployed as primary CQI platform across 4 states, 3 programme areas, 118 facilities',
    image: Images.NthripProjectCard,
    bgColor: 'purple',
    link: '/projects/clientshot-nthrip',
    published: true,
  },
  {
    id: 'cleft-surgery',
    title: 'Cleft and Surgery E-Registry',
    client: 'SmileTrain Inc. and Federal Ministry of Health Nigeria',
    sector: ['Surgery', 'Birth defects', 'National health information systems'],
    geography: ['Nationwide'],
    outcome: '3,055 patients registered across the full care continuum',
    image: Images.SmiletrainGallery3,
    bgColor: 'blue',
    link: '/projects/cleft-surgery',
    published: true,
  },
  {
    id: 'bridge',
    title: 'BRIDGE - Breast Health Risk Assessment, Detection, and Guidance Engine',
    client: 'Clinton Health Access Initiative (CHAI) - Bill and Melinda Gates Foundation',
    sector: ['Cancer detection', 'Community health', 'Rural health'],
    geography: ['Rural Nigeria'],
    outcome: 'Structured breast health assessment delivered to community health workers offline',
    image: Images.BridgeGallery3,
    bgColor: 'blue',
    link: '/projects/bridge',
    published: true,
  },
  {
    id: 'ekiti',
    title: 'Ekiti Laboratory Information Management and COVID Vaccination Tracking System',
    client: 'Ekiti State Ministry of Health and Human Services',
    sector: ['Laboratory services', 'Vaccination tracking'],
    geography: ['Ekiti State'],
    outcome: 'State-level LIMS and post-COVID vaccination tracking via USSD and WhatsApp',
    image: Images.EkitiKeyFeatures,
    bgColor: 'blue',
    link: '/projects/ekiti',
    published: true,
  },
  {
    id: 'kncv',
    title: 'KNCV Tuberculosis Patient Retention System',
    client: 'KNCV Tuberculosis Foundation Nigeria',
    sector: ['Tuberculosis', 'Patient retention'],
    geography: ['14 TB regions across 2 states'],
    outcome: 'SMS and USSD patient retention system across 14 TB regions',
    image: Images.KncvGallery3,
    bgColor: 'blue',
    link: '/projects/kncv',
    published: true,
  },
  {
    id: 'talamus',
    title: 'Talamus EHR Evaluation',
    client: 'Clinton Health Access Initiative (CHAI) - Lagos State Primary Health Care Board',
    sector: ['Electronic health records', 'Primary health care', 'System evaluation'],
    geography: ['Lagos State'],
    outcome: 'Structured EHR evaluation across 23 primary health care facilities in Lagos State',
    image: Images.TalamusProject,
    bgColor: 'blue',
    link: '/projects/talamus',
    published: true,
  },
  {
    id: 'opencrvs',
    title: 'OpenCRVS - Electronic Civil Registration and Vital Statistics System',
    client: 'UNICEF - National Population Council (NPC)',
    sector: ['Civil registration', 'Vital statistics', 'National information systems'],
    geography: ['Nationwide'],
    outcome: 'National electronic civil registration system built and implemented',
    image: Images.OpencrvsProjectCard,
    bgColor: 'blue',
    link: '/projects/opencrvs',
    published: true,
  },
  {
    id: 'smartest',
    title: 'SMARTest - HIV Testing Services Platform',
    client: 'Institute of Human Virology Nigeria (IHVN)',
    sector: ['HIV testing', 'Service delivery'],
    geography: ['Rivers State', 'FCT', 'Nasarawa State', 'Katsina State'],
    outcome: 'Mobile and web HIV testing platform deployed across 4 states',
    image: placeholderImg('SMARTest'),
    bgColor: 'blue',
    link: '/projects/smartest',
    published: true,
  },
]

const ProjectsIndex = () => {
  const [sectorFilter, setSectorFilter] = useState('All sectors')
  const [geographyFilter, setGeographyFilter] = useState('All geographies')

  const filteredProjects = allProjects.filter(p => {
    const hasImage = p.image && !String(p.image).startsWith('data:image/svg+xml')
    const sectorMatch = sectorFilter === 'All sectors' || p.sector.includes(sectorFilter)
    const geoMatch = geographyFilter === 'All geographies' || p.geography.includes(geographyFilter)
    return hasImage && sectorMatch && geoMatch
  })

  const clearFilters = () => {
    setSectorFilter('All sectors')
    setGeographyFilter('All geographies')
  }

  const hasActiveFilters = sectorFilter !== 'All sectors' || geographyFilter !== 'All geographies'

  return (
    <>
      <PageTitle title="Projects | SeamHealth Website " /> 
      <div id='address-section' className="project-section pt-52 flex justify-between flex-col overflow-hidden">
        <div className="md:w-2/4 gap-8 items-center p-8">
          <video id='project-video' autoPlay loop muted playsInline webkit-playsinline controls={false} disablePictureInPicture>
              <source src={Images.ProjectVid} type="video/mp4" />
          </video>
            <div className='text-white flex flex-col gap-6'>
              <div data-aos="fade-up">
                <Tag title={"Portfolio"} alt={true} />
              </div>
              <h1 data-aos="fade-up" className="text-5xl font-bold text-white">Our Work</h1>
            </div>
            <p data-aos="fade-up" className='text-white mt-3'>
            We have delivered digital health systems across Nigeria and Sub-Saharan Africa for governments, international organisations, and global health programmes.
            </p>
        </div>

        <div className="grid grid-cols-1 gap-8 items-end relative">
          <div className="w-full aspect-[16/9] md:aspect-[21/9] rounded-xl overflow-hidden">
            <img
              src={Images.ProjectStacks}
              alt="SeamHealth project deployments"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>

      {/* Filter System - Dropdowns */}
      <section className="py-6 px-4 md:px-8 bg-white border-b border-[#E6E6E6]">
        <div className="max-w-[1280px] mx-auto flex flex-col md:flex-row items-start md:items-center md:justify-center gap-4">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-3 w-full md:w-auto">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-2 w-full md:w-auto">
              <label className="md:hidden text-sm font-medium text-[#2A2A2A] whitespace-nowrap">Sector:</label>
              <select
                value={sectorFilter}
                onChange={e => setSectorFilter(e.target.value)}
                className="w-full md:w-auto px-3 py-2 text-sm border border-[#E6E6E6] rounded-lg bg-white text-[#2A2A2A] focus:outline-none focus:border-[#007DD6]"
              >
                {SECTOR_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
              </select>
            </div>
            <div className="flex flex-col md:flex-row items-start md:items-center gap-2 w-full md:w-auto">
              <label className="md:hidden text-sm font-medium text-[#2A2A2A] whitespace-nowrap">Geography:</label>
              <select
                value={geographyFilter}
                onChange={e => setGeographyFilter(e.target.value)}
                className="w-full md:w-auto px-3 py-2 text-sm border border-[#E6E6E6] rounded-lg bg-white text-[#2A2A2A] focus:outline-none focus:border-[#007DD6]"
              >
                {GEOGRAPHY_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
              </select>
            </div>
          </div>
          {hasActiveFilters && (
            <button onClick={clearFilters} className="text-sm text-[#007DD6] font-medium hover:underline whitespace-nowrap">
              Clear Filters
            </button>
          )}
        </div>
      </section>

      {/* Project Grid */}
      <section className='py-16 md:py-24 service-list px-4 md:px-8'>
        <div className="max-w-[1280px] mx-auto">
          <h1 className="text-5xl text-center mb-12">Projects</h1>
          {filteredProjects.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-8">
              {filteredProjects.map(p => (
                <ProjectCard
                  key={p.id}
                  image={p.image}
                  bgColor={p.bgColor}
                  title={p.title}
                  client={p.client}
                  sectorTags={p.sector}
                  geographyTags={p.geography}
                  outcome={p.outcome}
                  link={p.link}
                  published={p.published}
                  ctaLabel="View Case Study"
                  tag={false}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <p className="text-[#5B5B5B] text-lg">No projects match the selected filters. Try adjusting your selection or view all projects.</p>
              <button onClick={clearFilters} className="btn btn-primary mt-6">View All Projects</button>
            </div>
          )}
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="relative bg-gradient-to-br from-[#001630] to-[#002A4D] overflow-hidden">
        <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover z-[1] opacity-[0.2]">
          <source src={Images.ProjectVid} type="video/mp4" />
        </video>
        <div className="absolute inset-0 z-[2] bg-gradient-to-br from-[#001630]/60 to-[#002A4D]/60" />
        <div className="relative z-10 max-w-[1280px] mx-auto px-8 md:px-12">
          <div className="grid gap-12 items-stretch min-h-[420px] md:min-h-[520px]">
            <div className="flex flex-col justify-center py-12 md:py-20">
              <h1 data-aos="fade-up" className="text-5xl text-white tracking-tight">
                Looking for a delivery partner?
              </h1>
              <p data-aos="fade-up" className="text-lg text-white/70 mt-4 leading-relaxed max-w-[480px]">
                We work with governments, international organisations, and health programmes at every stage - from scoping and system design through to field deployment and long-term support.
              </p>
              <div data-aos="fade-up" className="mt-8">
                <Link to="/get-in-touch" className="btn btn-primary text-base w-fit">
                  Work With Us <img decoding="async" src={Images.ArrowUpRight} alt="" loading="lazy" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

const Project = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <Routes>
      <Route index element={<ProjectsIndex />} />
      <Route path=":slug" element={<ProjectShowcase />} />
    </Routes>
  )
}

export default Project
